import Vue from "vue"

import AsideMain from "./components/common/Aside-Main"
import HeaderMain from "./components/common/Header-Main"
import FooterMain from "./components/common/Footer-Main"

Vue.component('aside-main', AsideMain)
Vue.component('header-main', HeaderMain)
Vue.component('footer-main', FooterMain)